import { Input, Modal, Form } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Fragment, useState, useEffect, useCallback } from "react";
import styled from "@emotion/styled";
import { getMapApi, parseAddressComponents } from "../../utils/googleMap";
import { AddressEditMap } from "./addressEditMap";
import { PlacesAutoComplete } from "./placesAutocomplete";
import { Address } from "src/interface";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const AddressModal = styled(Modal)`
  top: 0px !important;
  padding-bottom: 0 !important;
  height: calc(100% - 16px) !important;

  .ant-modal-content {
    height: 100%;
  }

  .ant-modal-body {
    height: calc(100% - 55px);
    padding: 0;
  }
  .map-container {
    height: calc(100% - 180px);
  }
  form {
    padding: 20px;
    .ant-row {
      margin-bottom: 0;
    }
  }
`;

type AddressEditModalProps = {
  visible: boolean | undefined;
  onComplete: (address: unknown) => Promise<unknown>;
  onCancel: () => void;
};

function AddressEditModal({ visible, onComplete, onCancel }: AddressEditModalProps) {
  const [isMap, setIsMap] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [address, setAddress] = useState<Address>({});
  const [location, setLocation] = useState({});
  const [refresh, setRefresh] = useState(1);

  useEffect(() => {
    setIsMap(false);
    setRefresh(refresh + 1);
    setAddress({});
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'place' implicitly has an 'any' type.
  const onPlaceChange = useCallback((place) => {
    if (!place) {
      return;
    }
    setLocation(place.location);
    setAddress(place.address);
    setIsMap(true);
  }, []);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'markerLocation' implicitly has an 'any' type.
  const onLocationChange = async (markerLocation) => {
    setLoading(true);
    setLocation(markerLocation);
    void updateAddress(markerLocation);
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'markerLocation' implicitly has an 'any' type.
  const updateAddress = async (markerLocation) => {
    const mapApi = await getMapApi();
    const geocoder = new mapApi.Geocoder();
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'results' implicitly has an 'any' type.
    geocoder.geocode({ location: markerLocation }, (results, status) => {
      if (status !== "OK") {
        showErrorToast("Invalid address");
        return;
      }

      const [place] = results;

      const geocodeAddress = parseAddressComponents(place.address_components);

      setAddress({
        ...address,
        ...geocodeAddress,
        formatted: place.formatted_address,
        subpremise: "",
      });

      setLoading(false);
    });
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'event' implicitly has an 'any' type.
  const onLineChange = (event) => {
    setAddress({
      ...address,
      line1: event.target.value,
    });
  };

  const onOk = async () => {
    setSaving(true);
    try {
      await onComplete({
        location,
        address: {
          ...address,
          line1: address.line1 || "",
          subpremise: address.subpremise || "",
        },
      });
    } finally {
      setSaving(false);
    }
  };

  const onLocationFocus = () => setIsMap(false);

  return (
    <AddressModal
      title={null}
      closable={false}
      okText={isMap ? "Update Address" : "Next"}
      okButtonProps={{ disabled: !isMap || saving, loading: saving }}
      onOk={onOk}
      onCancel={onCancel}
      visible={visible}
    >
      {isMap ? (
        <Fragment>
          <div className="map-container">
            <AddressEditMap location={location} onChange={onLocationChange} />
          </div>
          <Form layout="vertical">
            <Form.Item label="Address">
              <Input
                value={loading ? "Fetching address" : address.formatted}
                onFocus={onLocationFocus}
              />
            </Form.Item>
            <Form.Item label="Apartment/ Floor/ Building">
              <Input
                placeholder="Apartment, e.g. “Unit 2”"
                onChange={onLineChange}
                value={address.subpremise || address.line1 || ""}
                disabled={Boolean(address.subpremise)}
              />
            </Form.Item>
          </Form>
        </Fragment>
      ) : (
        <Form layout="vertical">
          <Form.Item label="Search Location">
            <PlacesAutoComplete refresh={refresh} onChange={onPlaceChange} />
          </Form.Item>
        </Form>
      )}
    </AddressModal>
  );
}

export { AddressEditModal };
